<template>
  <a-card :bordered="false">
    <div>
      <a-table
        :data-source="table.data"
        :columns="table.columns"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <template slot-scope="text, record" slot="action">
          <div class="table-operation-wrap">
<!--            <a-button type="link" @click="editTax(record.id)"> {{ $t('EDIT') || '编辑' }}</a-button>-->
            <a-button type="link" @click="deleteAppointment(record.id)"> {{ $t('DELETE') || '删除' }}</a-button>
          </div>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { _queryAppointment, _delAppointment } from '@/api/websiteUserRequest';

async function getAppointmentList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryAppointment({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

async function deleteAppointment(id) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _delAppointment(id);
      this.$message.success('删除成功');
      await this.getAppointmentList();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
}

const columns = [
  {
    title: '用户名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'channel' },
  },
  {
    title: '用户Id',
    dataIndex: 'userId',
    scopedSlots: { customRender: 'channel' },
  },
  {
    title: 'title',
    dataIndex: 'title',
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '信息',
    dataIndex: 'message',
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '国家/地区',
    dataIndex: 'country',
    scopedSlots: { customRender: 'location' },
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    scopedSlots: { customRender: 'email' },
  },
  {
    title: '渠道',
    dataIndex: 'about',
    scopedSlots: { customRender: 'about' },
  },
  // {
  //   title: '拖拽排序',
  //   dataIndex: 'id',
  //   align: 'center',
  //   scopedSlots: { customRender: 'sort' },
  // },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'WebsiteAppointment',
  components: {},
  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns: columns,
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getAppointmentList,
    deleteAppointment,
  },
  created() {
    this.getAppointmentList();
  },
};
</script>

<style scoped>

</style>
